'use client';

import { c as _c } from "react/compiler-runtime";
import React, { Fragment, useState } from 'react';
import { Divider } from '@/app/components/divider';
import type { IconType } from '@/app/components/icons';
import { Icon } from '@/app/components/icons';
import { Container } from '@/app/components/layouts/container';
import { FOOTER_DATA_GA, FOOTER_DATA_TEST } from '@/app/components/layouts/footer/tracking';
import { Link } from '@/app/components/navigation/link';
import { Accordion } from '@/app/components/text-and-data-display/accordion';
import { FOOTER_COPYRIGHT } from '@/app/contents/footer';
import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { stripHtmlTags } from '@/app/utils/format';
const HeadingStyled = cnva('font-noto-bold text-body-1-fixed', {
  variants: {
    link: {
      true: 'transition-color hover:text-red-500'
    },
    accordion: {
      true: 'p-0 pb-3 text-gray-900 before:border-gray-50 hover:bg-transparent focus-visible:bg-transparent'
    }
  },
  defaultVariants: {
    link: false,
    accordion: false
  }
});
interface FooterLink {
  label?: string;
  labelHtml?: string;
  href?: string;
  target?: '_blank' | string | undefined;
}
interface FooterLinkWithIcon extends FooterLink {
  icon?: IconType;
}
export interface FooterNavItemProps {
  title?: FooterLink;
  isAccordion?: boolean;
  hasMenuHr?: boolean;
  menu?: {
    name?: string;
    links: FooterLinkWithIcon[];
  }[];
}
const FooterNavItem = t0 => {
  const $ = _c(29);
  const {
    title,
    isAccordion,
    hasMenuHr,
    menu: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const menu = t2;
  const [isOpen, setIsOpen] = useState(false);
  let t3;
  if ($[2] !== hasMenuHr || $[3] !== menu) {
    t3 = () => menu.map((t4, menuIndex) => {
      const {
        name,
        links
      } = t4;
      return <Fragment key={menuIndex}>{!!hasMenuHr && menuIndex > 0 && <Divider className="my-3" />}<div key={menuIndex} className="text-body-2-fixed space-y-2 text-gray-900 lg:space-y-1" {...createDataAttributes({
          test: "footer-navigation-items"
        })}>{!!name && <h4 className="font-noto-bold">{name}</h4>}{links.map(_temp)}</div></Fragment>;
    });
    $[2] = hasMenuHr;
    $[3] = menu;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const renderContent = t3;
  if (isAccordion) {
    const t4 = title?.label;
    const t5 = title?.label;
    let t6;
    if ($[5] !== t5) {
      t6 = stripHtmlTags(t5);
      $[5] = t5;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== isOpen) {
      t7 = () => setIsOpen(!isOpen);
      $[7] = isOpen;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] !== renderContent) {
      t8 = renderContent();
      $[9] = renderContent;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = HeadingStyled({
        accordion: true,
        className: "before:transition-form before:pointer-events-none before:absolute before:inset-0 before:border-b"
      });
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    let t10;
    if ($[12] !== isOpen || $[13] !== t4 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
      t10 = <Accordion title={t4} value={t6} isOpen={isOpen} onChange={t7} content={t8} className={t9} contentClassName="px-0 space-y-3 before:border-gray-50" />;
      $[12] = isOpen;
      $[13] = t4;
      $[14] = t6;
      $[15] = t7;
      $[16] = t8;
      $[17] = t9;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    return t10;
  }
  let t4;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "footer-navigation-group"
    });
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== title) {
    t5 = !!title && !!title.label && <>{title?.href ? <Link href={title.href} target={title.target} className={HeadingStyled({
        link: true
      })} {...createDataGA({
        click: true,
        eventName: FOOTER_DATA_GA.event,
        url: title.href,
        text: title.label
      })} dangerouslySetInnerHTML={{
        __html: title.label
      }} /> : <h3 className={HeadingStyled()} dangerouslySetInnerHTML={{
        __html: title.label
      }} />}</>;
    $[20] = title;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== menu.length || $[23] !== renderContent) {
    t6 = menu.length > 0 && <><Divider className="my-3" />{renderContent()}</>;
    $[22] = menu.length;
    $[23] = renderContent;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <div className="space-y-3" {...t4}>{t5}{t6}</div>;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
export type FooterNavColumn = FooterNavItemProps[];
export interface FooterNavProps {
  items: FooterNavColumn[];
}
export const FooterNav = t0 => {
  const $ = _c(8);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createDataAttributes({
      test: FOOTER_DATA_TEST.nav
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items) {
    t2 = items.map((column, columnIndex) => columnIndex % 2 === 0 && <div key={columnIndex} className="max-w-80 space-y-6 lg:grid lg:max-w-none lg:grid-cols-2 lg:space-y-0 lg:gap-x-6"><div className="space-y-6">{items[columnIndex].map(_temp2)}</div>{!!items[columnIndex + 1] && <div className="space-y-6">{items[columnIndex + 1].map(_temp3)}</div>}</div>);
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="grid grid-cols-2 gap-x-4 gap-y-6 py-6 lg:gap-x-6 lg:py-10">{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-caption py-6 text-gray-600 lg:text-right" {...createDataAttributes({
      test: "copyright"
    })}>{FOOTER_COPYRIGHT}</p>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div {...t1}><Container>{t3}{t4}</Container></div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(t0, linkIndex) {
  const {
    href,
    target,
    icon,
    label,
    labelHtml
  } = t0;
  return <Link key={linkIndex} href={href || ""} target={target} {...createDataAttributes({
    test: FOOTER_DATA_TEST.navLink
  })} {...createDataGA({
    click: true,
    eventName: FOOTER_DATA_GA.event,
    url: href,
    text: label || labelHtml
  })} className={cn("transition-color block hover:text-red-500", {
    "group flex gap-x-2": !!icon
  })}>{!!icon ? <><Icon className="transition-color text-gray-800 group-hover:text-red-500" icon={icon} />{labelHtml ? <span className="self-center" dangerouslySetInnerHTML={{
        __html: labelHtml
      }} /> : <span className="self-center">{label}</span>}</> : <>{labelHtml ? <span dangerouslySetInnerHTML={{
        __html: labelHtml
      }} /> : label}</>}</Link>;
}
function _temp2(item, itemIndex) {
  return <FooterNavItem key={itemIndex} {...item} />;
}
function _temp3(item_0, itemIndex_0) {
  return <FooterNavItem key={itemIndex_0} {...item_0} />;
}